export const BASE_PATH = process.env.REACT_APP_BASE_PATH
export const IS_BETA = process.env.REACT_APP_IS_BETA === '1' || process.env.REACT_APP_IS_BETA === 'true'
export const BASE_PATH_EXTENSION = process.env.REACT_APP_BASE_PATH_EXTENSION
export const BASE_PATH_EXTENSION_ADMIN = process.env.REACT_APP_BASE_PATH_EXTENSION_ADMIN
export const PATH_BASE_EXTENSION_USER = process.env.REACT_APP_BASE_PATH_EXTENSION_USER
export const TOKEN = process.env.REACT_APP_TOKEN
export const DASH_MAX_ROW = 50
